@if (showCameraPopUp) {
  <kx-camera-audio-permssion [device]="device" [resource]="resourceName"
  (closedevicePopup)="closedevicePopup($event)"></kx-camera-audio-permssion>
}

@if (faceImgCapture !=undefined && faceImgCapture) {
  <div id="video-container">
    <video id="video" autoplay></video>
    <div id="rectangle">
      <div class="top">
        <div class="square"></div>
        <div class="square1"></div>
      </div>
      <div class="bottom">
        <div class="square2"></div>
        <div class="square3"></div>
      </div>
    </div>
    <div align="center" class="camera-icon-container-wrapper">
      @if (photoClicked) {
        <button type="button" align="center" (click)="facePhoto()"
          class="image-upload-control-icons camera-click-icon">
          <i class="fa fa-camera" aria-hidden="true"></i>
        </button>
      }
      <!-- <button type="button" *ngIf="photoClicked && _webcamList.length > 1" align="center" (click)="clickPhoto()" class="primary-btn text-center">
      <i class="fa fa-camera" aria-hidden="true"></i>
    </button> -->
  </div>
</div>
}
@if (faceImgCapture !=undefined && !faceImgCapture) {
  <div>
    <video id="video" autoplay></video>
    <div align="center" class="camera-icon-container-wrapper">
      @if (photoClicked) {
        <button type="button" align="center" (click)="clickPhoto()"
          class="image-upload-control-icons camera-click-icon">
          <i class="fa fa-camera" aria-hidden="true"></i>
        </button>
      }
      <!-- <button type="button" *ngIf="photoClicked && _webcamList.length > 1" align="center" (click)="clickPhoto()" class="primary-btn text-center">
      <i class="fa fa-camera" aria-hidden="true"></i>
    </button> -->
  </div>
</div>
}

<canvas id="canvas"></canvas>
<!-- <div class="frame-overlay"></div> -->
@if (!photoClicked) {
  <div class="camera-icon-container-wrapper">
    <button type="button" (click)="correctImage()" class="image-upload-control-icons camera-select-image-icon">
      <i class="fa fa-check" aria-hidden="true"></i>
    </button>
    <button type="button" (click)="denyImage()" class="image-upload-control-icons camera-deselect-image-icon">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>
}